<nav class="navbar navbar-fixed-top">
  <div class="container-fluid">
    <div class="navbar-btn">
      <button type="button" class="btn-toggle-offcanvas"><i class="lnr lnr-menu fa fa-bars"></i></button>
    </div>

    <div class="navbar-brand">
      <a href="javascript:void(0)" style="color: #DB0009">
        <img src="../assets/images/logo/revcollect-logo.png" alt="RideReg" class="img-responsive logo">
        <!--rideReg-->
      </a>

    </div>

    <div class="navbar-right">
      <!-- <form id="navbar-search" class="navbar-form search-form col-lg-7 col-sm-3 col-md-4" (submit)="searchInitiator()">
        <input value="" class="form-control" placeholder="Search..." type="text">
        <button type="submit" class="btn btn-default"><i class="icon-magnifier"></i></button>
      </form> -->

      <div id="navbar-menu">
        <ul class="nav navbar-nav">
          <!-- <li class="dropdown"  data-balloon-pos="left" data-balloon="Wallet" *ngIf="getEligiblePermission()">
            <a href="javascript:void(0);" class="dropdown-toggle icon-menu" data-toggle="dropdown"><i class="icon-equalizer"></i></a>
            <ul class="dropdown-menu user-menu menu-icon" >
              <li class="menu-heading">Wallet: {{ wallet || 0 | currency: '&#8358;' }}</li>
              <li *ngIf="checkPrivilege(['super_agent'])"><a href="javascript:void(0);" (click)="triggerFundWallet();" class="text-white"><i class="icon-wallet"></i> <span>Fund Wallet</span></a></li>
            </ul>
          </li> -->
          <li  data-balloon-pos="left" data-balloon="Log out">
            <a href="javascript:void(0)" (click)="logOut()" class="icon-menu"><i class="icon-login"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
